import { createSlice } from "@reduxjs/toolkit";
import { fetchStudentGPIStatsData } from "../thunks/dashboardThunk"; 

const dashboarStudentGPIState = createSlice({
  name: "StudentGPIStats",
  initialState: {
    data: {
      data:[],
      statusCode:0,
      message:"",
      success:false
    },
    
    isLoading:false,
    isError:false
  },

  
  reducers: {},
  extraReducers: (builder) => {
    
    builder
      .addCase(fetchStudentGPIStatsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchStudentGPIStatsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data===""?[]:action.payload;
        
      })
      .addCase(fetchStudentGPIStatsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      
  },
});

export default dashboarStudentGPIState.reducer;